import LinesComponent from "slotworks/components/lines/lines-component";
import Point from "slotworks/utils/geom/point";
import Layers from "slotworks/graphics/layers/layers";

export default class SGLinesComponent extends LinesComponent {

    constructor(lineDefinitions: Point[][]) {
        super(lineDefinitions);
    }

    public win(id: number, reverse: boolean = false): void {

    }

    public highlight(id: number, reverse: boolean = false): void {
        super.highlight(id, reverse);
    }

    public hideAllLines() {
        for (const line of this.highlightLines) {
            line.visible = false;
        }
    }

    public tint(id: number, color: number) {
        this.highlightLines[id - 1].tint = color;
    }

    public filter(id: number, filters: Array<PIXI.Filter<any>>) {
        this.highlightLines[id - 1].filters = null;
        this.highlightLines[id - 1].filters = filters;
    }

    public draw(lineDefinitions: Point[][]) {
        this.highlightLines = [];

        for (let lineIndex = 0; lineIndex < lineDefinitions.length; lineIndex++) {
            const lineDefinition = lineDefinitions[lineIndex];

            let highlightLine: PIXI.Graphics | PIXI.Sprite;

            const highlightLineSprite = Layers.Paylines.getSprite("highlight_line_" + (lineIndex + 1));

            if (highlightLineSprite) {
                // Graphical lines (assetworks)
                highlightLine = highlightLineSprite;

                if (LinesComponent.lineFlips.has(lineIndex)) {
                    this.flip(lineIndex, highlightLine);
                }
            }
            highlightLine.visible = false;

            this.highlightLines.push(highlightLine);

            Layers.Paylines.add(highlightLine);
        }
    }
}
